
import { supabase } from "@/lib/supabase";
import { BillingSettings, Organization } from "@/types/organizationTypes";

export const useUpdateBillingSettings = (
  organization: Organization | null,
  setOrganization: (org: Organization) => void,
  organizationId?: string
) => {
  return async (settings: Partial<BillingSettings>): Promise<Organization | null> => {
    if (!organizationId || !organization) {
      throw new Error("Organization not loaded");
    }
    const updatedSettings = {
      ...(organization.billing_settings || {}),
      ...settings,
    };
    const { data, error } = await supabase
      .from("organizations")
      .update({ billing_settings: updatedSettings })
      .eq("id", organizationId)
      .select()
      .single();

    if (error) {
      throw new Error(error.message);
    }

    const updatedOrg = { ...organization, billing_settings: updatedSettings };
    setOrganization(updatedOrg);
    return updatedOrg;
  };
};
